"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadeInfo = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _api = require("../../../../api");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const ShadeInfo = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    currentShade,
    isMultiShade
  } = (0, _api.useGetReview)();
  if (!isMultiShade) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
    "data-testid": getTestId(_constants.SHADE_INFO),
    alignItems: "center",
    display: "flex",
    gap: 1,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Shade, {
      shade: currentShade,
      size: _presentationComponents.ShadeSize.Inline
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      color: "textSecondary",
      children: currentShade.name
    })]
  });
};
exports.ShadeInfo = ShadeInfo;
